const fields = [
  {
    key: 'numeroOT',
    label: 'Número OT',
    sortable: true
  },
  {
    key: 'tipoOT',
    label: 'Tipo OT',
    sortable: true
  },
  {
    key: 'taller',
    label: 'Taller',
    sortable: true
  },
  {
    key: 'patente',
    label: 'Patente',
    sortable: true
  },
  {
    key: 'km',
    label: 'Kilometraje',
    sortable: true
  },
  {
    key: 'asignacion',
    label: 'Asignación',
    sortable: true
  },
  {
    key: 'fechaInicio',
    label: 'Fecha Inicio',
    sortable: true
  },
  {
    key: 'fechaTermino',
    label: 'Fecha Fin',
    sortable: true
  },
  {
    key: 'diasTaller',
    label: 'Dias en Taller',
    sortable: true
  },
  {
    key: 'estado',
    label: 'Estado',
    sortable: true
  },
  {
    key: 'descarga',
    label: 'Descargar'
  }
];

const fieldsOT = [
  {
    key: 'otNumero',
    label: 'Número OT'
  },
  {
    key: 'descTipoOT',
    label: 'Tipo OT'
  },
  {
    key: 'descTaller',
    label: 'Taller'
  },
  {
    key: 'patente',
    label: 'Patente'
  },
  {
    key: 'km',
    label: 'Kilometraje'
  },
  {
    key: 'otNumeroSiniestro',
    label: 'Nro. Siniestro'
  },
  {
    key: 'otFechaEntrega',
    label: 'Fecha Devolución'
  },
  {
    key: 'diasTaller',
    label: 'Servicio (No valorizado)'
  },
  {
    key: 'descarga',
    label: 'Descargar'
  }
];
module.exports = {
  fields,
  fieldsOT
}
